import React from 'react';
import { useSelector } from 'react-redux';

const CompaniesDataLoading = () => {
  const companiesDataLoader = useSelector(state => state.Alerts.companiesDataLoader);

  return companiesDataLoader ? (
    <span style={{ whiteSpace: 'nowrap', fontSize: '10px', fontWeight: 700 }}>Loading Company Data...</span>
  ) : null;
};

export default CompaniesDataLoading;
